import type { Ref, RefObject } from 'react';

/** Whether a ref is an object ref (`useRef`), not a callback. */
export function isRefObject<T>(value: Ref<T> | undefined): value is RefObject<T> {
    return value != null && typeof value !== 'function';
}
